module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAMCAYAAAAd3Y8KAAAABHNCSVQICAgIfAhkiAAAABl0RVh0U29mdHdhcmUAZ25vbWUtc2NyZWVuc2hvdO8Dvz4AAABjSURBVEiJ7dQxCsAgDIXh+KiQ2SX3P1ydPEAypWtFhNIh0uK/xekjBJO7O30wrAa8bcOjO+6DqlJrbZVlmohQzrl76+BmRmetoagnlVIG+D9OBQAx8yrLNGDcb9r/eHAbHt0FYO4UGuCGBAIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dash.png
// module id = 1329
// module chunks = 0